export const x11Colors = {
    Pink: { hex: 'ffc0cb', rgb: '255,192,203' },
    LightPink: { hex: 'ffb6c1', rgb: '255,182,193' },
    HotPink: { hex: 'ff69b4', rgb: '255,105,180' },
    DeepPink: { hex: 'ff1493', rgb: '255,20,147' },
    PaleVioletRed: { hex: 'db7093', rgb: '219,112,147' },
    MediumVioletRed: { hex: 'c71585', rgb: '199,21,133' },
    LightSalmon: { hex: 'ffa07a', rgb: '255,160,122' },
    Salmon: { hex: 'fa8072', rgb: '250,128,114' },
    DarkSalmon: { hex: 'e9967a', rgb: '233,150,122' },
    LightCoral: { hex: 'f08080', rgb: '240,128,128' },
    IndianRed: { hex: 'cd5c5c', rgb: '205,92,92' },
    Crimson: { hex: 'dc143c', rgb: '220,20,60' },
    FireBrick: { hex: 'b22222', rgb: '178,34,34' },
    DarkRed: { hex: '8b0000', rgb: '139,0,0' },
    Red: { hex: 'ff0000', rgb: '255,0,0' },
    OrangeRed: { hex: 'ff4500', rgb: '255,69,0' },
    Tomato: { hex: 'ff6347', rgb: '255,99,71' },
    Coral: { hex: 'ff7f50', rgb: '255,127,80' },
    DarkOrange: { hex: 'ff8c00', rgb: '255,140,0' },
    Orange: { hex: 'ffa500', rgb: '255,165,0' },
    Gold: { hex: 'ffd700', rgb: '255,215,0' },
    Yellow: { hex: 'ffff00', rgb: '255,255,0' },
    LightYellow: { hex: 'ffffe0', rgb: '255,255,224' },
    LemonChiffon: { hex: 'fffacd', rgb: '255,250,205' },
    LightGoldenrodYellow: { hex: 'fafad2', rgb: '250,250,210' },
    PapayaWhip: { hex: 'ffefd5', rgb: '255,239,213' },
    Moccasin: { hex: 'ffe4b5', rgb: '255,228,181' },
    PeachPuff: { hex: 'ffdab9', rgb: '255,218,185' },
    PaleGoldenrod: { hex: 'eee8aa', rgb: '238,232,170' },
    Khaki: { hex: 'f0e68c', rgb: '240,230,140' },
    DarkKhaki: { hex: 'bdb76b', rgb: '189,183,107' },
    Cornsilk: { hex: 'fff8dc', rgb: '255,248,220' },
    BlanchedAlmond: { hex: 'ffebcd', rgb: '255,235,205' },
    Bisque: { hex: 'ffe4c4', rgb: '255,228,196' },
    NavajoWhite: { hex: 'ffdead', rgb: '255,222,173' },
    Wheat: { hex: 'f5deb3', rgb: '245,222,179' },
    BurlyWood: { hex: 'deb887', rgb: '222,184,135' },
    Tan: { hex: 'd2b48c', rgb: '210,180,140' },
    RosyBrown: { hex: 'bc8f8f', rgb: '188,143,143' },
    SandyBrown: { hex: 'f4a460', rgb: '244,164,96' },
    Goldenrod: { hex: 'daa520', rgb: '218,165,32' },
    DarkGoldenrod: { hex: 'b8860b', rgb: '184,134,11' },
    Peru: { hex: 'cd853f', rgb: '205,133,63' },
    Chocolate: { hex: 'd2691e', rgb: '210,105,30' },
    SaddleBrown: { hex: '8b4513', rgb: '139,69,19' },
    Sienna: { hex: 'a0522d', rgb: '160,82,45' },
    Brown: { hex: 'a52a2a', rgb: '165,42,42' },
    Maroon: { hex: '800000', rgb: '128,0,0' },
    DarkOliveGreen: { hex: '556b2f', rgb: '85,107,47' },
    Olive: { hex: '808000', rgb: '128,128,0' },
    OliveDrab: { hex: '6b8e23', rgb: '107,142,35' },
    YellowGreen: { hex: '9acd32', rgb: '154,205,50' },
    LimeGreen: { hex: '32cd32', rgb: '50,205,50' },
    Lime: { hex: '00ff00', rgb: '0,255,0' },
    LawnGreen: { hex: '7cfc00', rgb: '124,252,0' },
    Chartreuse: { hex: '7fff00', rgb: '127,255,0' },
    GreenYellow: { hex: 'adff2f', rgb: '173,255,47' },
    SpringGreen: { hex: '00ff7f', rgb: '0,255,127' },
    MediumSpringGreen: { hex: '00fa9a', rgb: '0,250,154' },
    LightGreen: { hex: '90ee90', rgb: '144,238,144' },
    PaleGreen: { hex: '98fb98', rgb: '152,251,152' },
    DarkSeaGreen: { hex: '8fbc8f', rgb: '143,188,143' },
    MediumSeaGreen: { hex: '3cb371', rgb: '60,179,113' },
    SeaGreen: { hex: '2e8b57', rgb: '46,139,87' },
    ForestGreen: { hex: '228b22', rgb: '34,139,34' },
    Green: { hex: '008000', rgb: '0,128,0' },
    DarkGreen: { hex: '006400', rgb: '0,100,0' },
    MediumAquamarine: { hex: '66cdaa', rgb: '102,205,170' },
    Aqua: { hex: '00ffff', rgb: '0,255,255' },
    Cyan: { hex: '00ffff', rgb: '0,255,255' },
    LightCyan: { hex: 'e0ffff', rgb: '224,255,255' },
    PaleTurquoise: { hex: 'afeeee', rgb: '175,238,238' },
    Aquamarine: { hex: '7fffd4', rgb: '127,255,212' },
    Turquoise: { hex: '40e0d0', rgb: '64,224,208' },
    MediumTurquoise: { hex: '48d1cc', rgb: '72,209,204' },
    DarkTurquoise: { hex: '00ced1', rgb: '0,206,209' },
    LightSeaGreen: { hex: '20b2aa', rgb: '32,178,170' },
    CadetBlue: { hex: '5f9ea0', rgb: '95,158,160' },
    DarkCyan: { hex: '008b8b', rgb: '0,139,139' },
    Teal: { hex: '008080', rgb: '0,128,128' },
    LightSteelBlue: { hex: 'b0c4de', rgb: '176,196,222' },
    PowderBlue: { hex: 'b0e0e6', rgb: '176,224,230' },
    LightBlue: { hex: 'add8e6', rgb: '173,216,230' },
    SkyBlue: { hex: '87ceeb', rgb: '135,206,235' },
    LightSkyBlue: { hex: '87cefa', rgb: '135,206,250' },
    DeepSkyBlue: { hex: '00bfff', rgb: '0,191,255' },
    DodgerBlue: { hex: '1e90ff', rgb: '30,144,255' },
    CornflowerBlue: { hex: '6495ed', rgb: '100,149,237' },
    SteelBlue: { hex: '4682b4', rgb: '70,130,180' },
    RoyalBlue: { hex: '4169e1', rgb: '65,105,225' },
    Blue: { hex: '0000ff', rgb: '0,0,255' },
    MediumBlue: { hex: '0000cd', rgb: '0,0,205' },
    DarkBlue: { hex: '00008b', rgb: '0,0,139' },
    Navy: { hex: '000080', rgb: '0,0,128' },
    MidnightBlue: { hex: '191970', rgb: '25,25,112' },
    Lavender: { hex: 'e6e6fa', rgb: '230,230,250' },
    Thistle: { hex: 'd8bfd8', rgb: '216,191,216' },
    Plum: { hex: 'dda0dd', rgb: '221,160,221' },
    Violet: { hex: 'ee82ee', rgb: '238,130,238' },
    Orchid: { hex: 'da70d6', rgb: '218,112,214' },
    Fuchsia: { hex: 'ff00ff', rgb: '255,0,255' },
    Magenta: { hex: 'ff00ff', rgb: '255,0,255' },
    MediumOrchid: { hex: 'ba55d3', rgb: '186,85,211' },
    MediumPurple: { hex: '9370db', rgb: '147,112,219' },
    BlueViolet: { hex: '8a2be2', rgb: '138,43,226' },
    DarkViolet: { hex: '9400d3', rgb: '148,0,211' },
    DarkOrchid: { hex: '9932cc', rgb: '153,50,204' },
    DarkMagenta: { hex: '8b008b', rgb: '139,0,139' },
    Purple: { hex: '800080', rgb: '128,0,128' },
    Indigo: { hex: '4b0082', rgb: '75,0,130' },
    DarkSlateBlue: { hex: '483d8b', rgb: '72,61,139' },
    SlateBlue: { hex: '6a5acd', rgb: '106,90,205' },
    MediumSlateBlue: { hex: '7b68ee', rgb: '123,104,238' },
    White: { hex: 'ffffff', rgb: '255,255,255' },
    Snow: { hex: 'fffafa', rgb: '255,250,250' },
    Honeydew: { hex: 'f0fff0', rgb: '240,255,240' },
    MintCream: { hex: 'f5fffa', rgb: '245,255,250' },
    Azure: { hex: 'f0ffff', rgb: '240,255,255' },
    AliceBlue: { hex: 'f0f8ff', rgb: '240,248,255' },
    GhostWhite: { hex: 'f8f8ff', rgb: '248,248,255' },
    WhiteSmoke: { hex: 'f5f5f5', rgb: '245,245,245' },
    Seashell: { hex: 'fff5ee', rgb: '255,245,238' },
    Beige: { hex: 'f5f5dc', rgb: '245,245,220' },
    OldLace: { hex: 'fdf5e6', rgb: '253,245,230' },
    FloralWhite: { hex: 'fffaf0', rgb: '255,250,240' },
    Ivory: { hex: 'fffff0', rgb: '255,255,240' },
    AntiqueWhite: { hex: 'faebd7', rgb: '250,235,215' },
    Linen: { hex: 'faf0e6', rgb: '250,240,230' },
    LavenderBlush: { hex: 'fff0f5', rgb: '255,240,245' },
    MistyRose: { hex: 'ffe4e1', rgb: '255,228,225' },
    Gainsboro: { hex: 'dcdcdc', rgb: '220,220,220' },
    LightGray: { hex: 'd3d3d3', rgb: '211,211,211' },
    Silver: { hex: 'c0c0c0', rgb: '192,192,192' },
    DarkGrey: { hex: 'a9a9a9', rgb: '169,169,169' },
    Grey: { hex: '808080', rgb: '128,128,128' },
    DimGrey: { hex: '696969', rgb: '105,105,105' },
    LightSlateGrey: { hex: '778899', rgb: '119,136,153' },
    SlateGrey: { hex: '708090', rgb: '112,128,144' },
    DarkSlateGrey: { hex: '2f4f4f', rgb: '47,79,79' },
    Black: { hex: '000000', rgb: '0,0,0' }
};
